import { createSelector } from 'reselect';

export const getIds = ({ error }) => error.list.allIds;
export const getById = ({ error }) => error.byId;
export const getError = (state, id) => state.error.byId[id];
export const getErrorList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));
